import React from 'react';
import styled from 'styled-components/macro';
import { commonStyle } from '../../../../../styles/theme/themes';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import { UseAxios } from '../../../../../utils/UseAxios';
import { apiList } from '../../../../../locales/apiList';
import { useDispatch } from 'react-redux';
import { translations } from '../../../../../locales/translations';
import { useWorkListStateSlice } from '../../../WorkListPage/slice';

export function UploadedFile(props) {
  const { fileData } = props;
  let worklistAction = useWorkListStateSlice().actions;
  const dispatch = useDispatch();

  const handleOpenFile = async () => {
    const index = fileData.key.indexOf('/');
    const subUrl = fileData.key.substring(index + 1, fileData.key.length);
    const downloadName = fileData.name;
    const url = new URL(`${apiList.getAttachmentURL}${subUrl}`, 'https://dummybaseforURL.com');

    url.searchParams.append('downloadName', downloadName);

    const urlResult = await UseAxios(
      url.pathname + url.search,
      'get',
    );
    if (urlResult?.data != null && !urlResult?.data?.error) {
      window.open(urlResult.data, '_blank');
    } else {
      dispatch(
        worklistAction.updateErrorWordings(translations.error.missingFile),
      );
      dispatch(worklistAction.updateErrorDialog(true));
    }
  };

  return (
    <Wrapper>
      {fileData.name.toLowerCase().includes('pdf') ? (
        <ArticleOutlinedIcon className="file-icon" />
      ) : (
        <InsertDriveFileOutlinedIcon className="file-icon" />
      )}
      <div onClick={handleOpenFile}>{fileData.name}</div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  border-radius: 5px;
  box-shadow: ${commonStyle.boxShadow};
  padding: 5px;
  align-items: center;
  margin-right: 10px;
  height: min-content;
  width: fit-content;
  display: flex;
  margin-bottom: 5px;
  cursor: pointer;
  user-select: none;

  :hover {
    opacity: 70%;
  }

  .file-icon {
    font-size: 20px;
    margin-right: 3px;
  }
`;
